import React from 'react';
import { Section, Template, TemplateHero, TemplateContent, TemplateAvatar } from './UiTemplateGallery.styles';
import { Column, Container, Markdown, Row, useAnalytics } from '../../components';
import { getColorsFromBackgroundField } from '../../styles';
export default function UiTemplateGalleryProps({ model }) {
    const { sendTrackEvent } = useAnalytics();
    const { templates } = model.content;
    return (React.createElement(Section, { "data-testid": "template-gallery" },
        React.createElement(Container, null,
            React.createElement(Row, { align: "center" }, templates
                .filter(({ type }) => type === 'trelloTemplate')
                .map(({ id, content }, index) => (React.createElement(Column, { md: { span: '6' }, lg: { span: '4' }, key: index },
                React.createElement(Template, { href: content.url, onClick: () => sendTrackEvent('clickedLinkInGallery', {
                        eventContainer: 'gallery',
                        event: 'clicked',
                        eventComponent: 'link',
                        label: content.title,
                        labelEnglish: content.entryTitle,
                        uuid: id,
                        href: content.url
                    }), "data-uuid": id, "data-testid": "individual-template" },
                    React.createElement(TemplateHero, Object.assign({}, getColorsFromBackgroundField(content.background))),
                    React.createElement(TemplateContent, null,
                        React.createElement(TemplateAvatar, { image: content.avatar, padding: content.avatarPadding }),
                        React.createElement("h3", null, content.title),
                        React.createElement("div", { className: "muted" },
                            React.createElement(Markdown, { links: false }, content.attribution)),
                        React.createElement("div", null,
                            React.createElement(Markdown, { links: false }, content.description)))))))))));
}
//# sourceMappingURL=UiTemplateGallery.js.map